import axios from 'axios'

const http = axios.create({
  baseURL: process.env.REACT_APP_ENV === 'development' ? 'https://baoup.top' : '',
})

export default http
